<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { ApiInsuranceAdditionalDetail } from '~~/server/api/insurance/additional/insurance/[slug]'
import type { AdditionalInsurancesData } from '~~/server/api/insurance/product'

export interface WidgetInsuranceAdditionalItemProps {
    data: AdditionalInsurancesData
    headingLevel: string
}

const props = defineProps<WidgetInsuranceAdditionalItemProps>()
const modalOpen = ref<boolean>(false)
const modalData = ref<ApiInsuranceAdditionalDetail>()
const key = computed<string>(() => `wiai-${props.data.slug}`)

const handleClick = async () => {
    // fetch data
    const data = await $fetch<ApiInsuranceAdditionalDetail>(
        `/api/insurance/additional/insurance/${props.data.slug}`
    )
    // open modal
    if (data) {
        modalData.value = data
        modalOpen.value = true
    }
}
</script>
<template>
  <article
    class="insurance-additional-item-wrapper h-100 position-relative cursor-pointer transition"
  >
    <Tracker :data="{ title: props.data.title }">
      <div
        class="insurance-additional-item py-10 px-4 text-center rounded transition h-100 d-flex flex-column justify-content-between"
      >
        <div class="mb-5">
          <img
            :src="props.data.icon?.path"
            width="30"
            height="34"
            alt=""
            loading="lazy"
            decoding="async"
            class="insurance-additional-item-image transition d-block mx-auto mb-5"
          >
          <Heading
            :level="props.headingLevel"
            class="epsilon transition"
          >
            {{ props.data.title }}
          </Heading>
        </div>
        <VNuxtLink
          :id="key"
          :to="{
            name: 'additional-insurance-detail',
            params: { id: props.data.slug },
          }"
          :aria-expanded="modalOpen"
          class="insurance-additional-item-link stretched-link text-decoration-none d-inline-block align-items-center fs-smaller"
          :label="$t('Detailný popis')"
          @click.prevent="handleClick"
        >
          <span class="visually-hidden">{{ props.data.title }}, </span>
          {{ $t('Detailný popis') }}
          <svg
            aria-hidden="true"
            class="insurance-additional-item-icon ms-1 transition"
            width="12"
            height="9"
          >
            <use xlink:href="#angle-right" />
          </svg>
        </VNuxtLink>
      </div>
    </Tracker>
  </article>
  <Modal
    v-if="modalOpen"
    :is-open="modalOpen"
    :labelled-by="`${key}-modal-title`"
    @close="modalOpen = false"
  >
    <Typo class="p-4 p-md-6">
      <h2
        :id="`${key}-modal-title`"
        class="mb-2 mb-md-4 delta"
      >
        {{ modalData?.data.title }}
      </h2>
      <div v-html="modalData?.data.description" />
    </Typo>
  </Modal>
</template>
<style lang="scss" scoped>
@import './WidgetInsuranceAdditionalItem.scss';
</style>
